import React from "react";
import PropTypes from "prop-types";
import { Form } from "react-final-form";
import {
  StyledPaginationButton,
  StyledPaginationButtons,
  StyledSubmitButton,
} from "../styled-components/StyledFinalForm";
import showPage from "../helpers/showPage";

export default class Wizard extends React.Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
  };
  static Page = ({ children }) => children;

  constructor(props) {
    super(props);
    this.state = {
      page: 0,
      values: props.initialValues || {},
    };
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (prevState.page !== this.state.page) {
      window.scrollTo(0, 0);
    }
  };

  next = (values) => {
    const { data, onSubmit } = this.props;
    let { page } = this.state;
    const pages = data?.readOneFeedbackForm?.Pages?.nodes;
    const nextPage = pages?.findIndex?.(
      (item, index) => index > page && showPage(item, values)
    );

    if (nextPage === -1) {
      onSubmit(values);
      return;
    }

    this.setState((state) => ({
      page: nextPage,
      values,
    }));
  };

  previous = () => {
    const { data } = this.props;
    let { page, values } = this.state;
    const pages = [...data?.readOneFeedbackForm?.Pages?.nodes].reverse();
    const prevPage = pages?.findIndex?.(
      (item, index) => page > pages.length - index - 1 && showPage(item, values)
    );

    if (prevPage === -1) {
      this.setState((state) => ({
        page: 0,
      }));
      return;
    }

    this.setState((state) => ({
      page: pages.length - prevPage - 1,
    }));
  };

  /**
   * NOTE: Both validate and handleSubmit switching are implemented
   * here because 🏁 Redux Final Form does not accept changes to those
   * functions once the form has been defined.
   */

  validate = (values) => {
    const activePage = React.Children.toArray(this.props.children)[
      this.state.page
    ];

    return activePage?.props?.validate ? activePage.props.validate(values) : {};
  };

  render() {
    const { children } = this.props;
    const { page, values } = this.state;
    const activePage = React.Children.toArray(children)[page];
    const isLastPage = page === React.Children.count(children) - 1;

    return (
      <Form
        initialValues={values}
        validate={(values) => {
          return this.validate(values);
        }}
        onSubmit={this.next}
      >
        {({ handleSubmit, submitting }) => {
          return (
            <form onSubmit={handleSubmit}>
              {activePage}
              <StyledPaginationButtons className="buttons">
                {page > 0 && (
                  <StyledPaginationButton
                    previous={true}
                    type="button"
                    onClick={this.previous}
                  >
                    « Previous
                  </StyledPaginationButton>
                )}
                {!isLastPage && (
                  <StyledPaginationButton type="submit">
                    Next »
                  </StyledPaginationButton>
                )}
                {isLastPage && (
                  <StyledSubmitButton
                    type="submit"
                    disabled={submitting || this.props.loading}
                  >
                    Submit
                  </StyledSubmitButton>
                )}
              </StyledPaginationButtons>
            </form>
          );
        }}
      </Form>
    );
  }
}
